import React, { useState } from 'react';
import { getIconByProductId } from '../helper';
import { colors } from '@atlaskit/theme';
// @ts-ignore
import AppIcon from '../assets/img/icon-app.svg';
import { PRODUCTION, getEnvironment } from '@atlassian/temp-shared';

interface Props {
  productId?: string | null;
  [iconProps: string]: any;
  isCloud?: boolean;
  logoId?: string | null;
  isNewJiraIconEnabled?: boolean;
}

export default function EntitlementIcon({ productId, isCloud, logoId, ...iconProps }: Props) {
  const [isError, setError] = useState(false);
  if (logoId) {
    const marketplaceAppRenderServiceBaseUrl =
      getEnvironment() === PRODUCTION
        ? 'https://marketplace.atlassian.com/files'
        : 'https://marketplace.stg.internal.atlassian.com/files';
    return (
      <img
        loading="lazy"
        // @ts-ignore causing issue because of Webpack handling this properly
        src={!isError ? `${marketplaceAppRenderServiceBaseUrl}/${logoId}` : AppIcon}
        alt="app-logo"
        onError={() => {
          setError(true);
        }}
        height="100%"
        width="100%"
        {...iconProps}
      />
    );
  }

  const ProductIcon = getIconByProductId(productId as string);

  if (typeof ProductIcon === 'function') {
    // special check for UnknownIcon because it is an img tag with no props like iconColor, etc.
    return isCloud && ProductIcon.name !== 'UnknownIcon' ? (
      <ProductIcon
        {...iconProps}
        iconColor={colors.B200}
        iconGradientStart={colors.B400}
        iconGradientStop={colors.B200}
      />
    ) : (
      <ProductIcon {...iconProps} />
    );
  }

  return isCloud ? (
    <img
      loading="lazy"
      src={ProductIcon}
      {...iconProps} //@ts-ignore
      iconColor={colors.B200}
      iconGradientStart={colors.B400}
      iconGradientStop={colors.B200}
    />
  ) : (
    <img src={ProductIcon} {...iconProps} />
  );
}
